module.exports = __webpack_public_path__ + "static/media/UN-07.70470df2.jpg";